import { isBrowser } from "utils/infrastructure/ssg-utils"

export function getParameterFromUrl(parameter: string) {
    if (!isBrowser()) return
    const url = new URL(window.location.href)

    return url.searchParams.get(parameter)
}
